<template>
    <td-dialog :visible.sync="dialogetSeriesButtonVisible" :title="$t('pgCommon.SET_SERIES_BUTTON')" :before-close="cancel" :close-on-click-modal="false" :append-to-body="true" width="1150px">
        <el-row>
            <el-col style="margin-bottom: 20px;">
                <td-button type="primary" @click="addTab"> {{ $t('pgCommon.ADD_SET_SERIES_BUTTON') }}</td-button>
            </el-col>
        </el-row>
        <div v-for="(item, index) in addDesignDataSourceList" :key="item" style="margin-bottom: 20px;">
            <span style="margin-right: 20px;">{{ $t('pgCommon.PLEASE_SET_SERIES_BUTTON') }}</span>
            <td-select style="margin-top: 10px;" keys="id" text="name" :options="options" :collapse-tags="true" :multiple="true" v-model="item.sSeriesButtonList"> </td-select>
            <span style="margin-right: 20px;margin-left: 40px;">{{ $t('pgCommon.PLEASE_SET_SERIES_BUTTON_NAME') }}</span>
            <td-input v-model="item.sButtonName" :maxlength="100"></td-input>
            <span style="margin-right: 20px;margin-left: 40px;">{{ $t('pgCommon.SHOW_ORDER') }}</span>
            <td-input-number v-model="item.iButtonOrder" :min="0"></td-input-number>
            <td-button style="margin-left: 20px; " type="primary" @click="removeTab(index)">{{ $t('pgCommon.DELETE') }}</td-button>
        </div>
        <span slot="footer">
            <td-button type="primary" @click="save" :loading="loading">{{ $t('pgCommon.SAVE') }}</td-button>
            <td-button @click="cancel">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import api from '../assets/api.js';
export default {
    props: {
        dialogetSeriesButtonVisible: {
            type: Boolean
        },
        designParam: {
            type: Object
        },
        templateKey: {
            type: String
        },
        taskForm: {
            type: Object
        }
    },
    created() {
        this.addDesignDataSourceList = [];
        this.getOptions();
        this.echoData();
    },
    data() {
        return {
            addDesignDataSourceList: [],
            options: []
        };
    },
    methods: {
        echoData() {
            let param = {
                sIgn: this.templateKey + ':' + this.taskForm.taskKey,
                sProDefId: this.templateKey + ':TEMP'
            };
            //老接口有冲突，新版本使用temp接口查询
            api.getSteSeriesButtonDataBySIgn(param, response => {
                let temp = [];
                let temp1 = [];
                temp = response.data.content;
                for (let i = 0; i < temp.length; i++) {
                    let param = {
                        sButtonName: temp[i].sButtonName,
                        sSeriesButtonList: JSON.parse(temp[i].sSeriesButtonList),
                        iButtonOrder: temp[i].iButtonOrder,
                        sid: temp[i].sId,
                        sProDefId: this.templateKey + ':TEMP'
                    };
                    temp1.push(param);
                }
                this.addDesignDataSourceList = temp1;
            });
        },
        save() {
            if (this.addDesignDataSourceList.length == 0) {
                this.$message({
                    message: this.$t('pgCommon.SERIES_BUTTON_AND_BUTTON_NAME_NOT_EMPTY'),
                    type: 'warning'
                });
                return;
            }
            let tempIButtonOrder = [];
            for (let i = 0; i < this.addDesignDataSourceList.length; i++) {
                if (this.addDesignDataSourceList[i].iButtonOrder > 2147483647) {
                    this.$message({
                        message: this.$t('pgCommon.NUMBER_OVER_MAXIMUM'),
                        type: 'warning'
                    });
                    return;
                }
                if (
                    this.addDesignDataSourceList[i].sSeriesButtonList.length == 0
                ) {
                    this.$message({
                        message: this.$t('pgCommon.SERIES_BUTTON_NOT_EMPTY'),
                        type: 'warning'
                    });
                    return;
                }
                if(this.addDesignDataSourceList[i].sButtonName == '' ||
                    this.addDesignDataSourceList[i].sButtonName.indexOf(' ') >= 0) {
                    this.$message({
                        message: this.$t('pgCommon.BUTTON_NAME_NOT_EMPTY'),
                        type: 'warning'
                    });
                    return;              
                }
                tempIButtonOrder.push(this.addDesignDataSourceList[i].iButtonOrder);
            }
            let uniq = this.unique(tempIButtonOrder);
            if (this.addDesignDataSourceList.length != uniq.length) {
                this.$message({
                    showClose: true,
                    message: this.$t('pgCommon.BUTTON_ORDER_NOT_ALIKE'),
                    type: 'warning'
                });
                return;
            }
            api.savSteSeriesButtonData(JSON.stringify(this.addDesignDataSourceList), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    return;
                }
                this.$message({ type: 'success', showClose: true, message: this.$t('pgCommon.SAVE_SUCCESS') });
                this.cancel();
            });
        },
        unique(array) {
            //一个新的数组
            var arrs = [];
            //遍历当前数组
            for (var i = 0; i < array.length; i++) {
                //如果临时数组里没有当前数组的当前值，则把当前值push到新数组里面
                if (arrs.indexOf(array[i]) == -1) {
                    arrs.push(array[i]);
                }
            }
            return arrs;
        },
        removeTab(index) {
            this.$confirm(this.$t('pgCommon.WHETHER_DELETE'), this.$t('extendCommon.TIPS'), {
                confirmButtonText: window.vue.$t('extendCommon.CONFIRM'),
                cancelButtonText: window.vue.$t('extendCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    if (this.addDesignDataSourceList[index].sid != undefined) {
                        let param = {
                            sid: this.addDesignDataSourceList[index].sid
                        };
                        api.delSteSeriesButtonDataBySid(param, response => {
                            if (response.status !== this.$common.login.RESPONSE_STATUS) {
                                return;
                            }
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                return;
                            }
                            this.$message({ type: 'success', showClose: true, message: this.$t('pgCommon.DELETE_SUCCESS') });
                            this.addDesignDataSourceList.splice(index, 1);
                        });
                    } else {
                        this.addDesignDataSourceList.splice(index, 1);
                    }
                })
                .catch(() => {});
        },
        addTab() {
            let cope = {
                sSeriesButtonList: [],
                sButtonName: '',
                sIgn: this.templateKey + ':' + this.taskForm.taskKey,
                sProDefId: this.templateKey + ":TEMP",  //新增的为临时版本
                iButtonOrder: 0
            };
            this.addDesignDataSourceList.push(cope);
        },
        getOptions() {
            let param = {
                templateId: this.designParam.templateId,
                taskKey: this.designParam.taskKey
            };
            api.getTaskOutgoings(param, response => {
                let tempOptions = [];
                tempOptions = response.data.content.targetTaskKeys;
                let tempNames = response.data.content.targetTaskNames;
                for (let i = 0; i < tempOptions.length; i++) {
                    let O = {
                        id: tempOptions[i],
                        name: tempNames[i]
                    };
                    this.options.push(O);
                }
            });
        },
        cancel() {
            this.$emit('setSeriesButtonDialogColse');
        }
    }
};
</script>
